import { render } from "./monture.vue?vue&type=template&id=efd83e1c&scoped=true"
import script from "./monture.vue?vue&type=script&lang=js"
export * from "./monture.vue?vue&type=script&lang=js"

import "./monture.vue?vue&type=style&index=0&id=efd83e1c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd83e1c"]])

export default __exports__